import yup, { yupInterval, yupUUID } from "../../../utils/yup";
import { eventKeySchemaShape } from "../../event/types";

const rawIntervalSchema = yup
  .object({
    years: yup.number().optional(),
    months: yup.number().optional(),
    weeks: yup.number().optional(),
    days: yup.number().optional(),
  })
  .nullable();

const scheduleSchemaShape = {
  id: yupUUID,
  send_at: yup
    .string()
    .test("valid date", "Time must be hours and minutes", (t) => t !== "Invalid Date")
    .required("Select the time to send the Communication"),
  interval: yupInterval.nullable(),
  interval_json: rawIntervalSchema,
  event: yup
    .object(eventKeySchemaShape)
    .required("Select the event that triggers the Communication"),
  event_initial: yup.boolean().required(),
  event_repeat: yup.boolean().required(),
  on_event_key: yup
    .array(yup.string().required())
    .min(1, "You must select at least one day that this Communication can be sent on")
    .nullable()
    .defined(),
};

export const scheduleSchema = yup.object(scheduleSchemaShape);
